import { SceneFade } from "../shared3d/SceneFade";
import { Stage } from "../shared3d/Stage";
import { Title } from "../shared3d/Title";
import { Caption } from "../shared3d/Caption";
import { Node3D, DataParticle } from "../shared3d/Diagram3D";
import { neon } from "../shared3d/Materials";
import { BRAND } from "../shared3d/theme";
import { byScene } from "./script";

// client -> [RLS filter plane] -> rows. Particles stream at the plane; the
// matching-tenant ones pass, others are stopped at the plane.
export const Scene04Approach: React.FC = () => (
  <SceneFade>
    <Stage orbit={0.1} cameraZ={9}>
      {/* client */}
      <Node3D position={[-4, 0, 0]} color={BRAND.cyan} size={0.5} />
      {/* RLS filter plane */}
      <mesh position={[0, 0, 0]} rotation={[0, 0, 0]}>
        <boxGeometry args={[0.12, 3.4, 3.4]} />
        <meshStandardMaterial
          {...neon(BRAND.green, 0.9)}
          transparent
          opacity={0.5}
        />
      </mesh>
      {/* rows behind the plane */}
      {[1.1, 0, -1.1].map((y, i) => (
        <Node3D key={i} position={[3.4, y, 0]} color={BRAND.blue} size={0.3} />
      ))}
      {/* allowed query passes through */}
      <DataParticle
        from={[-4, 0, 0]}
        to={[3.4, 0, 0]}
        startFrame={60}
        travelFrames={120}
        color={BRAND.green}
        size={0.14}
      />
      {/* a foreign query stops at the plane */}
      <DataParticle
        from={[-4, 1.1, 0]}
        to={[-0.2, 1.1, 0]}
        startFrame={300}
        travelFrames={70}
        color={BRAND.magenta}
        size={0.14}
      />
    </Stage>
    <Title text="Row-Level Security" place="top" size={64} delay={4} />
    <Caption lines={byScene.approach} />
  </SceneFade>
);

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
